export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section id="top" className="hero-section relative w-full overflow-hidden md:h-[780px]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/images/hero.jpg')" }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/55 to-primary-950/75" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/60 via-transparent to-transparent" />

      <div className="hero-inner relative z-10 w-full min-h-[100svh] md:h-full px-5 md:px-10 lg:px-14 flex items-start md:items-center pt-24 pb-10 md:py-0">
        <div className="w-full max-w-4xl fade-up">
          <div className="hero-eyebrow hidden md:flex items-center gap-3 mb-6">
            <div className="w-10 h-[1px] bg-accent-300" />
            <span className="text-[11px] tracking-[0.35em] text-accent-100 uppercase">
              Root Cause Laboratory
            </span>
          </div>

          <div className="mb-6">
            <span className="inline-block px-3 py-1 border border-background-50/30 rounded-sm text-[11px] tracking-[0.25em] text-background-100">
              原因究明研究所
            </span>
          </div>

          <h1 className="hero-title font-heading text-background-50 mb-6">
            <span className="block">問題は、</span>
            <span className="block md:inline">解き明かされることを</span>
            <span className="block md:inline">待っています。</span>
          </h1>

          <p className="text-[15px] md:text-xl text-background-200 leading-[1.9] md:leading-relaxed max-w-2xl mb-8 md:mb-10">
            不良現象と向き合い、解決策を導きます。
            <br />
            素材・加工から組立・検査まで。
            <br className="hidden md:block" />
            現象を観察し、仮説と検証を重ねながら原因を絞り込みます。
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              onClick={() => scrollTo("contact")}
              className="inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3.5 md:py-4 bg-primary-500 hover:bg-primary-400 text-background-50 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              お問い合わせ
            </button>
            <button
              onClick={() => scrollTo("service")}
              className="inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3.5 md:py-4 border border-background-50/40 hover:border-background-50/70 text-background-50 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              サービス内容を見る
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="hero-summary mt-10 md:mt-14 max-w-2xl">
            <div className="hero-summary-item border-l border-background-50/20 pl-4 py-1">
              <div className="text-[10px] md:text-[11px] tracking-[0.2em] text-accent-200 mb-1.5 md:mb-2">FIELDS</div>
              <div className="text-background-50 text-lg md:text-xl font-heading">5領域</div>
              <div className="text-xs text-background-300 mt-1">金属・樹脂・ガラス・蒸着・組立検査</div>
            </div>
            <div className="hero-summary-item border-l border-background-50/20 pl-4 py-1">
              <div className="text-[10px] md:text-[11px] tracking-[0.2em] text-accent-200 mb-1.5 md:mb-2">APPROACH</div>
              <div className="text-background-50 text-lg md:text-xl font-heading">観察・仮説・検証</div>
              <div className="text-xs text-background-300 mt-1">現象から原因を絞り込む</div>
            </div>
            <div className="hero-summary-item border-l border-background-50/20 pl-4 py-1">
              <div className="text-[10px] md:text-[11px] tracking-[0.2em] text-accent-200 mb-1.5 md:mb-2">FEE</div>
              <div className="text-background-50 text-lg md:text-xl font-heading">固定費＋成果報酬</div>
              <div className="text-xs text-background-300 mt-1">原因究明・改善設計費20万円＋改善額の10%</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2">
        <span className="text-[10px] tracking-[0.3em] text-background-200">SCROLL</span>
        <div className="w-[1px] h-10 bg-background-50/40" />
      </div>
    </section>
  );
}
